import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/Services/auth.service';
import { NavbarService } from 'src/app/Services/navbar-service/navbar.service';

@Component({
    selector: 'app-executive-top-nav',
    templateUrl: './executive-top-nav.component.html',
    styleUrls: ['./executive-top-nav.component.scss'],
})
export class ExecutiveTopNavComponent implements OnInit {
  lgaName: string = '';
  userName = ''
  constructor(
    private navbarService: NavbarService,
    private authService: AuthService
  ) { }

  isSideNavOpen;

  user: any;

  
  

  ngOnInit(): void {
    this.navbarService.getSidebarState().subscribe((isSideNavOpen: boolean) => {
      this.isSideNavOpen = isSideNavOpen;
    })

    this.authService.userSubject.subscribe((user) => {
      this.user = user;
      console.log('user', this.user)
    })

  }

  toggleSideNav() {
    this.navbarService.toggleMobileSidebarOpen()
  }

  logout () {
    this.authService.logout(true)
  }

}
